import { ReactNode } from 'react';
import { ButtonSize } from '../../../types/v2/button';

type ButtonBaseProps = {
  text?: ReactNode;
  textSize?: ButtonSize;
};

const size = {
  sm: 'text-xs',
  base: 'text-sm',
  lg: 'text-md',
  md: 'text-base',
};

export default function ButtonBase(props: ButtonBaseProps) {
  const { text, textSize } = props;

  const styles = `tracking-wide font-text font-medium ${
    size[textSize || 'base']
  }`;

  return <span className={styles}>{text}</span>;
}
